import { render } from "./PatientDataSpinner.vue?vue&type=template&id=25ae3bc7&scoped=true&ts=true"
import script from "./PatientDataSpinner.vue?vue&type=script&lang=ts"
export * from "./PatientDataSpinner.vue?vue&type=script&lang=ts"

import "./PatientDataSpinner.vue?vue&type=style&index=0&id=25ae3bc7&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ae3bc7"]])

export default __exports__